import api from "../axiosConfig";

const getCars = async () => {

    const { data } = await api.get("/api/Cars");

    return data;

};

const getCar = async (id) => {

    const { data } = await api.get(`/api/Cars/${id}`);

    return data;

};

const createCar = async (formData) => {

    const { data } = await api.post(
        "/api/Cars",
        formData
    );

    return data;

};

const updateCar = async (id, formData) => {

    const { data } = await api.put(
        `/api/Cars/${id}`,
        formData
    );

    return data;

};

const deleteCar = async (id) => {

    const { data } = await api.delete(
        `/api/Cars/${id}`
    );

    return data;

};

const editKilometer = async (id, kilometer) => {

    const formData = new FormData();

    formData.append("kilometer", kilometer);

    const { data } = await api.put(
        `/api/Cars/EditKilometer/${id}`,
        formData
    );

    return data;

};

const carService = {

    getCars,

    getCar,

    createCar,

    updateCar,

    deleteCar,

    editKilometer,

};

export default carService;

